/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Ask_RoleInputs */



/**
* | output |
* | --- |
* | "And what's your role?" |
*
* @param {Onboarding_Ask_RoleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const onboarding_ask_role = /** @type {((inputs?: Onboarding_Ask_RoleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Ask_RoleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Und was ist deine Rolle?")
	return /** @type {LocalizedString} */ ("And what's your role?")
});